module.exports = __webpack_public_path__ + "static/media/pic23.6d597722.jpg";